"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollArea = exports.ctx = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.ctx = React.createContext(null);
const useScrollArea = () => React.useContext(exports.ctx);
exports.useScrollArea = useScrollArea;
